import React from "react";
import { CalendarIcon, CameraIcon, LayersIcon, SunIcon, UsersIcon, BoxIcon } from "lucide-react";
export type ScreenId = 'today' | 'schedule' | 'crew' | 'shots' | 'kit';
const tabs: {
  id: ScreenId;
  label: string;
  Icon: BoxIcon;
}[] = [{
  id: 'today',
  label: 'Today',
  Icon: SunIcon
}, {
  id: 'schedule',
  label: 'Schedule',
  Icon: CalendarIcon
}, {
  id: 'crew',
  // Relabelled "Crew" -> "Contacts" 9 Sep 2026 at Tom's request — the
  // screen behind this tab (pages/Crew.tsx) lists the portal team, extra
  // crew, client contacts and featured guests together, so "Contacts"
  // reads better than "Crew" for what's actually in there. The internal
  // ScreenId stays 'crew' — renaming it would touch App.tsx, Today.tsx,
  // ShootContext.tsx and the role plumbing for no user-visible benefit.
  label: 'Contacts',
  Icon: UsersIcon
}, {
  id: 'shots',
  label: 'Shots',
  Icon: CameraIcon
}, {
  id: 'kit',
  label: 'Kit',
  Icon: LayersIcon
}];
interface BottomNavProps {
  active: ScreenId;
  onNavigate: (screen: ScreenId) => void;
  /** Which tabs to show, in order — defaults to all five. The client link
      (added 9 Sep 2026) passes just ['today', 'schedule', 'crew'], leaving
      out Shots and Kit entirely rather than showing them disabled. A crew
      link with no shot list filled in also drops 'shots' — see App.tsx. */
  visible?: ScreenId[];
}
export function BottomNav({
  active,
  onNavigate,
  visible
}: BottomNavProps) {
  const shown = visible ? tabs.filter(tab => visible.includes(tab.id)) : tabs;
  return <nav aria-label="Main" className="shrink-0 border-t border-line bg-ink" data-id="element-28" data-mp="wpoqrfmvdxnm">
      <ul className="flex" data-id="element-29" data-mp="hy6f1u11mpa2">
        {shown.map(({
        id,
        label,
        Icon
      }) => {
        const isActive = id === active;
        return <li key={id} className="flex-1" data-id="element-30" data-mp="1ann4citd9q22">
              <button type="button" onClick={() => onNavigate(id)} aria-current={isActive ? 'page' : undefined} className="flex h-[68px] w-full flex-col items-center justify-center gap-1.5 focus:outline-none focus-visible:ring-1 focus-visible:ring-fg" data-id="element-31" data-mp="1alshgyyjbnvc">
                <Icon className={`h-[18px] w-[18px] transition-colors duration-150 ease-out ${isActive ? 'text-fg' : 'text-dim'}`} strokeWidth={1.5} data-id="element-32" data-mp="1kb8w2sg97iws" />
                <span className={`text-[9px] font-medium uppercase tracking-label transition-colors duration-150 ease-out ${isActive ? 'text-fg' : 'text-dim'}`} data-id="element-33" data-mp="1fabeoi32iswc">
                  {label}
                </span>
              </button>
            </li>;
      })}
      </ul>
    </nav>;
}